import { useState, useEffect } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import { useAuth } from "../../../contexts/auth";
import { updateConfig } from "../../../services/api";
import {
  requestNotificationPermission,
  areNotificationsEnabled,
  shouldUseFCM,
} from "../../../services/notifications";
import { fetchToken } from "../../../firebase";

import TimeIntervalToggle from "./TimeIntervalToggle";
import RenderReceiveNotificationsSwitch from "./RenderReceiveNotificationsSwitch";
import RenderSaveButton from "./RenderSaveButton";

const Settings = () => {
  const { user } = useAuth();

  const [show, setShow] = useState(false);
  const [receiveNotifications, setReceiveNotifications] = useState(false);
  const [disableRadioButtons, setDisableRadioButtons] = useState(false);
  const [disableSaveButton, setDisableSaveButton] = useState(true);
  const [isLoading, setLoading] = useState(false);

  const timeIntervalOptions = [1, 5, 10, 30, 60];
  const [radioValue, setRadioValue] = useState(5);

  const handleInitialValues = () => {
    setReceiveNotifications(user?.receiveNotifications ?? false);
    setDisableRadioButtons(!user?.receiveNotifications ?? false);
    setRadioValue(user?.timeInterval ?? 5);
  };

  useEffect(() => {
    handleInitialValues();
  }, [user]);

  useEffect(() => {
    setDisableSaveButton(
      receiveNotifications === user.receiveNotifications &&
        radioValue === user.timeInterval
    );
  }, [receiveNotifications, radioValue]);

  const handleReceiveNotification = async () => {
    if (!receiveNotifications) {
      if (shouldUseFCM()) {
        // Para dispositivos móveis, usa FCM
        const token = await fetchToken(user.id);
        if (!token) {
          alert(
            "Não foi possível configurar as notificações. Por favor, verifique as permissões do navegador."
          );
          return;
        }
      } else {
        // Para desktop, usa notificações locais
        const hasPermission = await requestNotificationPermission();
        if (!hasPermission) {
          alert(
            "É necessário permitir as notificações para receber alertas de alarmes."
          );
          return;
        }
      }
    }
    setReceiveNotifications(!receiveNotifications);
    setDisableRadioButtons(receiveNotifications);
  };

  const handleSaveConfigurations = async () => {
    setLoading(true);
    const response = await updateConfig(
      user.id,
      receiveNotifications,
      radioValue
    );

    if (response.status === 204) {
      setDisableSaveButton(true);
      user.receiveNotifications = receiveNotifications;
      user.timeInterval = radioValue;
      localStorage.setItem("asu", JSON.stringify(user));
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        variant="outline-light"
        onClick={() => setShow(true)}
        className="rounded-circle"
      >
        <i className="bi bi-gear-fill"></i>
      </Button>

      <Offcanvas show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Configurações</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <RenderReceiveNotificationsSwitch
            receiveNotifications={receiveNotifications}
            handleReceiveNotification={handleReceiveNotification}
          />

          <TimeIntervalToggle
            timeIntervalOptions={timeIntervalOptions}
            radioValue={radioValue}
            onChange={setRadioValue}
            disableRadioButtons={disableRadioButtons}
          />

          <RenderSaveButton
            disableSaveButton={disableSaveButton}
            handleSaveConfigurations={handleSaveConfigurations}
            isLoading={isLoading}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Settings;
